export default {
  LIST_NAME: 'layouts_list',
};
